/**
 *
 *
 * */

document.addEventListener("DOMContentLoaded", () => {
    const formState = {
        dropdown_region: 0,
        dropdown_schoolboards: 0,
        dropdown_schools: 0,
        radio_paths: 0,
    };

    const fieldId = (document.querySelector('.radio_paths ul.gfield_radio'))?document.querySelector('.radio_paths ul.gfield_radio').id:0;

    onInit();

    function onInit() {
        const formsSelectList = Object.entries(formState);

        /**
         * Create a array of promise to make all the call on the load of the page
         * ( and mostly for the jquery change page)
         */
        const promiseArray = formsSelectList.map((form, index ) => {
            if (form[1] && index + 1 < formsSelectList.length) {
                toggleLoadingState(0, true);
                return refreshContentData(formsSelectList[index + 1][0], form[1]);
            }
            return null;
        });

        /**
         * Run the value of the promise ( the html response or null )
         * and replace the html for each section if required
         */
        Promise.all(promiseArray).then((values) => {
            toggleLoadingState(0, false);
            if (!values[0]) {
                const selectElement = document.querySelector(`.${formsSelectList[0][0]} select`);
                setOption(selectElement, 0);
            }
            values.forEach((data, index) => {
                var res = JSON.parse(data);
                if (res) {
                    const selectElement = document.querySelector(`.${formsSelectList[index+1][0]} select`);
                    const radioElement = document.querySelector(`.${formsSelectList[index+1][0]} ul.gfield_radio`);
                    const currentElement = res[formsSelectList[index+1][0]];
                    if (selectElement) {
                        selectElement.innerHTML = currentElement;
                        setOption(selectElement, formsSelectList[index+1][1]);
                    } else if(radioElement) {
                        if (document.querySelector('.live-near')) {
                            radioElement.insertAdjacentHTML('afterbegin', currentElement);
                        } else {
                            radioElement.innerHTML = currentElement;
                        }
                        setRadio(radioElement, formsSelectList[index+1][1]);
                    }
                }
            });
            loadForm();
        });

        /**
         * Add the action to fetch next section when the user select a new value
         */
        formsSelectList.forEach((item, index) => {
            const htmlElement = document.querySelector(`.${item[0]}`);

            if (htmlElement) {
                htmlElement.addEventListener('change', (e) => {
                    formState[formsSelectList[index][0]] = e.target.value;
                    resetValue(index);
                    toggleLoadingState(index, true);
                    if (index + 1 < formsSelectList.length ) {
                        if (e.target && e.target.querySelectorAll('option')) {
                            const optionList = Array.from(e.target.querySelectorAll('option'));
                            const selectedOption = optionList[e.target.selectedIndex];
                                               if (selectedOption && selectedOption.dataset) {
                                Object.entries(selectedOption.dataset).forEach(data => {
                                    const selectElement = document.querySelector(`.dropdown_${data[0]} select`);
                                    if (selectElement) {
                                        formState[`dropdown_${data[0]}`] = data[1];
                                        setOption(selectElement, data[1]);
                                    }
                                });
                            }
                        }
                        fetchNextData(formsSelectList[index + 1][0], e.target.value);
                    }
                }, false);
            }
        });

        fetchNextData('dropdown_schoolboards', formsSelectList[0][1]);
        fetchNextData('dropdown_schools', formsSelectList[1][1]);
    }

    function fetchNextData(sectionName, itemValue) {
        const callValue = refreshContentData(sectionName, itemValue);

        callValue.then((response) => {

            const responseObj = JSON.parse(response);
            //console.log(responseObj);
            var resEntries = Object.entries(responseObj);
            resEntries.forEach((res) => {
                const selectElement = document.querySelector(`.${res[0]} select`);
                const radioElement = document.querySelector(`.${res[0]} ul.gfield_radio`);
                if (selectElement) {
                    selectElement.innerHTML = res[1];
                    setOption(selectElement, formState[res[0]]);
                } else if (radioElement) {
                    radioElement.innerHTML = res[1];
                    setRadio(radioElement, formState[res[0]]);
                }
            });

            toggleLoadingState(0, false);

        });


    }

    function setOption(selectElement, value) {
        if (selectElement) {
            const optionsArray = Array.from(selectElement.querySelectorAll('option'));
            return optionsArray.some((option, index) => {
                if (option.value == value) {
                    selectElement.selectedIndex = index;
                    return true;
                }
            });
        }
    }

    function removeOptions(selectElement) {
        const optionsArray = Array.from(selectElement.querySelectorAll('option'));
        optionsArray.forEach((option, index) => {
            option.remove();
        });
    }

    function setRadio(radioElement, value) {
        const radioArray = Array.from(radioElement.querySelectorAll('input'));

        return radioArray.some((input, index) => {
            if (input.value == value) {
                input.checked = true;
                return true;
            }
        });
    }

    function resetValue(startPoint) {
        const formsSelectList = Object.entries(formState);

        formsSelectList.forEach((input, index) => {
            if (index > startPoint) {
                const selectElement = document.querySelector(`.${input[0]} select`);
                const radioElement = document.querySelector(`.${input[0]} ul.gfield_radio`);
                formState[input[0]] = 0;
                if (selectElement) {
                    removeOptions(selectElement);
                    setOption(selectElement, 0);
                } else if (radioElement) {
                    const radioArray = Array.from(radioElement.querySelectorAll('input'));
                    return radioArray.forEach((input) => {
                        input.checked = false;
                    });
                }
            }
        });
    }

    function toggleLoadingState(startPoint, isToggle) {
        const formsSelectList = Object.entries(formState);

        formsSelectList.forEach((input, index) => {
            if (index > startPoint) {
                const inputContainer = document.querySelector(`.${input[0]}`);

                if (inputContainer) {
                    if (isToggle) {
                        inputContainer.classList.add('is-loading');
                    } else {
                        inputContainer.classList.remove('is-loading');
                    }
                }
            }
        });
    }

    /**
     * 
     * HTTP Call to fetch content of each section dynamicly
     * @param {string} sectionName - The name of the section to fetch ( determine by the `formState` object and the class asign via wordpress )
     * @param {string} itemValue  - The value of the previous item
     * 
     * @returns {Promise} - Return a async Promise
     */
    function refreshContentData(sectionName, itemValue) {
        return new Promise( (resolve, reject) => {
            const request = new XMLHttpRequest();
            request.open('POST', ajax_gf_params.ajaxurl, true);
            request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
            request.onreadystatechange = (evt) => {
                if (evt.currentTarget.readyState === 4 && evt.currentTarget.status === 200) {
                    try {
                        const response = evt.currentTarget.response;
                        resolve(response);
                    } catch (exception) {
                        reject(exception);
                    }
                }
            };
            request.onerror = () => {
                reject(exception);
            };

            //const fieldInfo = document.querySelector('.radio_paths ul.gfield_radio')?.id || 0;
            var buff = document.querySelector('.radio_paths ul.gfield_radio');
            const fieldInfo = buff?buff.id:0;
            const ddRegion = formState.dropdown_region;
            request.send(`action=update_${sectionName}&inputId=${itemValue}&fieldId=${fieldInfo}&ddRegion=${ddRegion}`);
        });
    }

    /**
     * jQuery handler to detect "page" changed and refetch all the needed data
     */
    if (jQuery) {
        jQuery(document).on('gform_post_render', (event, form_id, current_page) => {
            //console.log('gform_post_render');
            onInit(); 
        });
    }

    /**
     *
     * @type {NodeListOf<Element>}
     * Autofill fields with recurring data between forms
     *
     * keypress, not optimal, but GF input mask for phone / postal code does not trigger the change event
     */
    document.addEventListener( "change", storeForm );
    document.addEventListener( "keypress", storeForm );

    function storeForm(event){
        var element = event.target;
        if(element.tagName == 'INPUT' || element.tagName == 'SELECT'){
            //console.log('storeForm');
            var container = element.closest(".autofill");
            if(container){
                var classList = container.classList;
                classList.forEach((item, index) => {
                    if (item.indexOf('autofill-') > -1) {
                        //console.log(item + ' : ' + element.value);
                        localStorage.setItem(item, element.value);
                    }
                });
            }

        }
    }

    function loadForm(){
        //console.log('loadForm');
        var formFields = ['prenom', 'nom', 'telephone', 'ext', 'courriel', 'nocivique', 'rue', 'apt', 'ville', 'codepostal', 'region', 'schoolboards', 'schools', 'paths'];

        formFields.forEach((item, index) => {
            var value = localStorage.getItem('autofill-'+item);
            //console.log(`${item} : ${value}`);
            var selectElement = document.querySelector(`.autofill-${item} select`);
            var radioElement = document.querySelector(`.autofill-${item} ul.gfield_radio`);
            var inputElement = document.querySelector(`.autofill-${item} input`);
            if(selectElement){
                selectElement.value = value;
            }else if (radioElement){
                var radio = document.querySelector(`.autofill-${item} ul.gfield_radio input[value="${value}"]`);
                if(radio){
                    radio.checked = true;
                }
            }else if(inputElement){
                inputElement.value = value;
            }

            var formEntries = Object.entries(formState);
            formEntries.forEach((entry, index) => {
                if (entry[0] == `dropdown_${item}`) {
                    formState[entry[0]] = value > 0 ? value : null;

                }else if (entry[0] == `radio_${item}`) {
                    formState[entry[0]] = value;

                }
            });

            if(item == 'schools') {
                fetchNextData('radio_paths', value);
            }

        });
    }

    if ($('.forms-stepbar').length) {
        $('.forms-header').addClass('has-stepbar');
    }

});


